













import Component, { mixins } from 'vue-class-component';

import UrlMixin from '@/mixins/url';

import Logo from '@/components/Molecules/Image/Logo.vue';

import MobileGnavButton from '@/components/Atoms/Button/MobileGnavButton.vue';
import MegaMenu from '@/components/Organisms/Header/MegaMenu.vue';

@Component({
  components: {
    Logo,
    MobileGnavButton,
    MegaMenu,
  },
})
export default class Header extends mixins(UrlMixin) {}
